'use client';

import { __styles } from "@griffel/react";
import { typographyStyles } from "@fluentui/react-theme";
export const caption2StrongClassNames = {
  root: 'fui-Caption2Strong'
};
/**
 * Styles for the root slot
 */
export const useCaption2StrongStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "f13mqy1h",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fcpl73t"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".f13mqy1h{font-size:var(--fontSizeBase100);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fcpl73t{line-height:var(--lineHeightBase100);}"]
});